















































































































































































import { Component } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamHeader from '@/components/ExamHeader.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import AlertModal from '@/components/AlertModal.vue';

import * as DesignCode from '@/classification/DesignCode';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';
import * as Msgs from '@/common/Messages';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamRankDetail from '@/models/rank/ExamRankDetail';
import DesignResource from '@/models/exam/DesignResource';
import Rank from '@/models/rank/Rank';

@Component(
  {
    components: {
      'e-header': ExamHeader,
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      'e-alert-modal': AlertModal,
    },
  },
)
export default class ExamDetail extends BaseView {
  private ExamRepository = RepositoryFactory.get().exam;

  private RankRepository = RepositoryFactory.get().rank;

  private GuestRepository = RepositoryFactory.get().guest;

  private rank = new ExamRankDetail();

  private examTitle = '';

  private inPeriod = false;

  private rankFee = '';

  private otherRanks = new Array<Rank>();

  private resources = {
    EXAM_RANK_ICON: new DesignResource(),
    BENEFITS_ICON: new DesignResource(),
    EXAM_DETAIL_BENEFITS_BG: new DesignResource(),
    EXAM_DETAIL_BENEFITS_MAIN_COLOR: new DesignResource(),
    EXAM_DETAIL_BENEFITS_SUB_TITLE_COLOR: new DesignResource(),
    BENEFITS_BADGE_ALL: new DesignResource(),
    BENEFITS_BADGE_PASS: new DesignResource(),
    BENEFITS_BADGE_PERFECT: new DesignResource(),
  };

  private isIndicatorDisplay = false;

  private displayAlertModal = false;

  private modalTitle = '';

  private titleCssClass = '';

  private cancelButtonLabel = 'Close';

  /**
   * 料金設定が不足しているか否か
   */
  get isUnsetFee(): boolean {
    return this.rank.examFeeType === 'pay' && this.rank.fees.length <= 0;
  }

  private created() {
    // 不正なクエリパラメータの場合、TOPに遷移
    if (StringUtil.isEmpty(this.$route.query.rank)) {
      this.$router.replace(this.paths.TOP);
    }
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ExamDetailCss = document.createElement('link');
    ExamDetailCss.rel = 'stylesheet';
    ExamDetailCss.href = '/kentei/css/detail.css';
    this.$el.appendChild(ExamDetailCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    this.init();
  }

  @Watch('$route', { immediate: true, deep: true })
  private onUrlChange(to: any, from: any) {
    // 変更情報が存在しない場合は何もしない
    if (!to || !from) return;

    // rankパラメータが存在しない場合何もしない（createdでTOPに戻す）
    if (StringUtil.isEmpty(to.query.rank) || StringUtil.isEmpty(from.query.rank)) {
      return;
    }

    if (to.query.rank !== from.query.rank) {
      // インスタンスの再生成が行えないためデータ取得処理を再呼び出し
      this.init();
    }
  }

  /**
   * 初期データセット
   */
  private async init() {
    this.isIndicatorDisplay = true;
    await this.getExam();
    await this.getRankInfo();
    await this.getRankList();
    this.isIndicatorDisplay = false;
  }

  /**
   * 検定情報取得
   */
  private async getExam() {
    try {
      await this.ExamRepository.getExam().then((response) => {
        this.examTitle = response.data.exam_title;
        this.inPeriod = response.data.in_period;

        // デザインリソース
        if (response.data.resources !== undefined) {
          response.data.resources.forEach((resource: any) => {
            const key = resource.display_place_key;
            if (key in this.resources) {
              const tmp = new DesignResource();
              tmp.displayPlaceKey = resource.display_place_key;
              tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
              tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
              tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
              tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
              tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              this.resources[key] = tmp;
            }
          });
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 検定ランク情報取得
   */
  private async getRankInfo() {
    const paramRankCode = String(this.$route.query.rank);
    try {
      await this.RankRepository.getRankInfo(paramRankCode).then((response) => {
        if (response.status === 200) {
          try {
            this.rank = this.RankRepository.convert.deserialize(response.data, ExamRankDetail) as ExamRankDetail;
          } catch (e) {
            throw Error(Msgs.INVALID_RESPONSE);
          }
          // 日付(YYYY/MM/DD)、金額(カンマ区切り)、概要(マークダウン)の整形
          this.rank.examinationPeriodStart = ExamDetail.formatDate(this.rank.examinationPeriodStart);
          this.rank.examinationPeriodEnd = ExamDetail.formatDate(this.rank.examinationPeriodEnd);
          this.rank.requestPeriodStart = ExamDetail.formatDate(this.rank.requestPeriodStart);
          this.rank.requestPeriodEnd = ExamDetail.formatDate(this.rank.requestPeriodEnd);
          if (this.rank.fees.length > 0) {
            this.rankFee = StringUtil.separateNumber(this.rank.fees[0].fee);
          } else {
            this.rankFee = '0';
          }
          this.rank.overview = MarkdownToHTML(this.rank.overview);

          // 特典の説明、注意事項のマークダウン整形
          this.rank.benefits.forEach((value) => {
            const benefit = value;
            benefit.explanation = MarkdownToHTML(benefit.explanation);
            benefit.notes = MarkdownToHTML(benefit.notes);
          });

          // eslint-disable-next-line prefer-destructuring
          const resources = response.data.resources;
          if (resources !== undefined && resources.length > 0) {
            resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                this.rank.thumbnail = resource.resource_uri;
                this.rank.alternativeText = resource.alternative_text;
              }
            });
          }
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 検定ランク一覧取得
   *  表示中のランク以外の一覧を表示する
   */
  private async getRankList() {
    await this.RankRepository.getRanks().then((response) => {
      if (response.status === 200 && response.data.exam_ranks !== undefined) {
        const tmp = new Array<Rank>();
        response.data.exam_ranks.forEach((otherRank: any) => {
          if (this.rank.examRankCode === otherRank.exam_rank_code) {
            return;
          }

          const rankObj = new Rank();
          rankObj.rankCode = StringUtil.encodeToBase64Url(otherRank.exam_rank_code);
          rankObj.title = otherRank.exam_rank_title;
          if (otherRank.fees.length > 0) {
            rankObj.fee = StringUtil.separateNumber(otherRank.fees[0].fee);
          } else {
            rankObj.fee = '0';
          }
          rankObj.paymentType = otherRank.exam_fee_type;

          // eslint-disable-next-line prefer-destructuring
          const resources = otherRank.resources;
          if (resources !== undefined && resources.length > 0) {
            resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                rankObj.thumbnail = resource.resource_uri;
                rankObj.alternativeText = resource.alternative_text;
              }
            });
          }

          tmp.push(rankObj);
        });
        this.otherRanks = tmp;
      }
    });
  }

  /**
   * 申し込み画面へ遷移
   */
  private async transitionToEntry() {
    const rankCode = StringUtil.encodeToBase64Url(String(this.rank.examRankCode));

    if (!this.rank.registrationRequired) {
      this.isIndicatorDisplay = true;
      try {
        // アカウント不要検定の申込を行う
        await this.GuestRepository.guestEntry(String(this.rank.examRankCode)).then((response: any) => {
          if (response.status === 201) {
            const entryCode = response.data.examination_entry_code;

            // eslint-disable-next-line @typescript-eslint/camelcase
            this.$router.replace({ path: this.paths.EXAM_READY, query: { rank: rankCode, examination_entry_code: entryCode } });
          }
        });
      } catch (error) {
        this.$router.replace(this.paths.TOP);
      } finally {
        this.isIndicatorDisplay = false;
      }
    } else {
      const jwt = JwtUtil.getJwtInfo();
      if (jwt == null) {
        // 未ログインの場合、ログイン/仮登録画面へ
        this.$router.replace({ path: this.paths.LOGIN, query: { rank: rankCode } });
      } else {
        // ログイン済みの場合、内容確認画面へ
        this.$router.replace({ path: this.paths.ACCOUNT_CONFIRM, query: { rank: rankCode } });
      }
    }
  }

  /**
   * 日付整形処理
   */
  private static formatDate(strDate: any) {
    const str = String(strDate);
    if (StringUtil.isEmpty(str)) {
      return '';
    }
    return StringUtil.toJapanDateString(str, 'MM/DD/YYYY hh:mm A');
  }

  /**
   * UAチェック
   * ※意図した判定ができなくなるため無闇に判定順序を変えないこと
   */
  private checkUA() {
    // 適切な環境かどうか
    let isBrowserValid = false;
    const userAgent = window.navigator.userAgent.toLowerCase();

    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      // --- IE(11も含め対象外とする) --- //
      isBrowserValid = false;
    } else if (userAgent.indexOf('edge') !== -1) {
      // --- Edge --- //
      const version = userAgent.match(/(?:edge\/)(.*?\d)(?=\.)/);
      isBrowserValid = (version !== null && parseInt(version[1], 10) >= 18);
    } else if (userAgent.indexOf('opr') !== -1) {
      // --- Opera(新しいバージョン) --- //
      isBrowserValid = false;
    } else if (userAgent.indexOf('chrome') !== -1) {
      // --- Chrome --- //
      const version = userAgent.match(/(?:chrome\/)(.*?\d)(?=\.)/);
      if (userAgent.indexOf('android') !== -1) {
        isBrowserValid = (version !== null && parseInt(version[1], 10) >= 80);
      } else {
        isBrowserValid = (version !== null && parseInt(version[1], 10) >= 79);
      }
    } else if (userAgent.indexOf('safari') !== -1) {
      // --- Safari --- //
      const version = userAgent.match(/(?:version\/)(\d+\.\d*)(?=[ .])/);
      if (userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('iphone') !== -1) {
        // iOS版
        isBrowserValid = (version !== null && parseFloat(version[1]) >= 12.0);
      } else {
        // PC版
        isBrowserValid = (version !== null && parseFloat(version[1]) >= 12.1);
      }
    } else if (userAgent.indexOf('firefox') !== -1) {
      // --- Firefox --- //
      const version = userAgent.match(/(?:firefox\/)(.*?\d)(?=\.)/);
      isBrowserValid = (version !== null && parseInt(version[1], 10) >= 68);
    } else if (userAgent.indexOf('opera') !== -1) {
      // --- Opera(古いバージョン) --- //
      isBrowserValid = false;
    } else {
      isBrowserValid = false;
    }

    if (isBrowserValid) {
      this.modalTitle = 'This device is capable of running the quiz.';
      this.titleCssClass = '';
    } else {
      this.modalTitle = 'This device is not capable of running the quiz.';
      this.titleCssClass = 'color-alert';
    }

    this.displayAlertModal = true;
  }

  /**
   * モーダルのキャンセルボタン押下時処理
   */
  private modalCancelButtonClick() {
    this.displayAlertModal = false;
  }
}
